import React, { ReactElement } from 'react';
import { Form } from 'react-bootstrap';
import { Filters, HeaderGroup, Row, SortingRule } from 'react-table';

export const mapFiltersToRequest = (filters: Filters<object>): string => {
  return filters.map((filter) => `&${filter.id}=${encodeURIComponent(filter.value)}`).join('');
};

export const mapSortToRequest = (sorters: SortingRule<object>[]): string => {
  return sorters.map((sorter) => `&sort=${sorter.id},${sorter.desc ? 'desc' : 'asc'}`).join('');
};

type CreateRowsFromPageType = {
  headerGroups: HeaderGroup<object>[];
  page: Row[];
  prepareRow: (row: Row) => void;
  pageSize: number;
  onRowDoubleClick?: (row: Row) => void;
};

export const createRowsFromPage = ({
  headerGroups,
  page,
  prepareRow,
  pageSize,
  onRowDoubleClick,
}: CreateRowsFromPageType): ReactElement[] => {
  const rows: ReactElement[] = [];

  for (let i = 0; i < pageSize; i++) {
    const row = page[i];

    if (row) {
      prepareRow(row);
      // Extraction de la key pour le <tr>
      const { key: rowKey, ...rowProps } = row.getRowProps();

      rows.push(
        <tr
          key={rowKey}
          {...rowProps}
          {...(onRowDoubleClick
            ? {
                onDoubleClick: () => onRowDoubleClick(row),
                style: {
                  ...rowProps.style,
                  cursor: 'zoom-in',
                },
              }
            : {})}
        >
          {row.cells.map((cell: any) => {
            // Extraction de la key pour le <td>
            const { key: cellKey, ...cellProps } = cell.getCellProps();
            return (
              <td key={cellKey} {...cellProps}>
                {cell.render('Cell')}
              </td>
            );
          })}
        </tr>
      );
    } else if (Array.isArray(headerGroups) && headerGroups.length > 0) {
      const cells: ReactElement[] = headerGroups[0].headers.map((column) => {
        // Extraction de la key pour le <td> vide
        const { key: headerKey, ...headerProps } = column.getHeaderProps();
        return <td key={headerKey} {...headerProps} />;
      });

      rows.push(
        <tr className="empty-row" key={i}>
          {cells}
        </tr>
      );
    }
  }

  return rows;
};

// COMPONENTS

export const DefaultColumnFilter = ({ column: { filterValue, setFilter } }: any): ReactElement => {
  return (
    <Form.Control
      type="text"
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
    />
  );
};
